import React from "react";
import { ScrollText, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * RecentActivity — Compact timeline card for recent platform-level actions.
 */
const RecentActivity = ({ activities = [] }) => {
  const navigate = useNavigate();

  return (
    <div className="sa-card">
      <div className="sa-card-head">
        <div className="sa-card-head-left">
          <div className="sa-card-icon violet"><ScrollText size={18} /></div>
          <div>
            <div className="sa-card-title">Recent Activity</div>
            <div className="sa-card-subtitle">Platform-wide audit trail</div>
          </div>
        </div>
        <button className="sa-card-action" onClick={() => navigate("/sa/audit-logs")}>
          View all <ArrowRight size={14} />
        </button>
      </div>
      <div className="sa-card-body">
        {activities.length === 0 ? (
          <div className="sa-empty">No recent activity</div>
        ) : (
          <div className="sa-timeline">
            {activities.map((act, i) => (
              <div key={act._id || i} className="sa-timeline__item">
                <div className="sa-timeline__dot" />
                <div className="sa-timeline__content">
                  <div className="sa-timeline__text">{act.action}</div>
                  <div className="sa-timeline__meta">
                    {act.adminName && <span>{act.adminName}</span>}
                    {act.instituteName && <span className="sa-timeline__sep">·</span>}
                    {act.instituteName && <span>{act.instituteName}</span>}
                    <span className="sa-timeline__sep">·</span>
                    <span>{act.timeAgo || "just now"}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivity;
